import { render } from "./NcAccordion.vue?vue&type=template&id=7928e973&scoped=true"
import script from "./NcAccordion.vue?vue&type=script&lang=js"
export * from "./NcAccordion.vue?vue&type=script&lang=js"

import "./NcAccordion.vue?vue&type=style&index=0&id=7928e973&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7928e973"]])

export default __exports__